import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap5";

export default class extends Controller {
  static targets = [
    "btn",
    "wbtn",
  ];

  intialize() {
    this.modalShow = this.onModalShow.bind(this);
    this.disposeBound = this.dispose.bind(this);
  }

  connect() {
    this.element.addEventListener("show.bs.modal", this.modalShow);
    this.modalInst = Modal.getOrCreateInstance(this.element);
    this.element.addEventListener("hidden.bs.modal", this.disposeBound);
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this.modalShow);
    this.element.removeEventListener("hidden.bs.modal", this.disposeBound);
  }

  dispose() {
    this.modalInst.dispose();
  }

  cancelSub(){
    $(this.btnTargets).addClass("d-none");
    $(this.wbtnTarget).removeClass("d-none");


    $("#subscription_cancel").val(true);
    $("#subscription_form")[0].requestSubmit();

  }
}